module.exports = __webpack_public_path__ + "img/jifen.6f173db1.png";